export default "__VITE_ASSET__CuR$QATe__"